import { Card, CardContent } from '@/components/ui/card'
import { Building2 } from 'lucide-react'
import { Skeleton } from '@/components/ui/skeleton'

interface ClinicStatsCardProps {
  totalClinics: number
  clinicsOnMap: number
  isLoading?: boolean
}

export default function ClinicStatsCard({
  totalClinics,
  clinicsOnMap,
  isLoading,
}: ClinicStatsCardProps) {
  if (isLoading) {
    return (
      <Card className="bg-white/95 backdrop-blur-sm shadow-lg">
        <CardContent className="p-4">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-6 w-20 mt-2" />
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className="bg-white/95 backdrop-blur-sm shadow-lg hover:shadow-xl transition-shadow">
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Building2 className="h-6 w-6 text-blue-600" />
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-600">總診所數量</h3>
            <p className="text-2xl font-bold text-gray-900">{totalClinics}</p>
            <p className="text-xs text-gray-500 mt-1">地圖顯示 {clinicsOnMap} 間</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
